<template>
  <g>
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
      :stroke="borderColor"
      fill="transparent"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.19772 10.6609C4.16912 10.6895 4.16056 10.7325 4.17604 10.7698C4.19152 10.8072 4.22798 10.8316 4.26843 10.8316L8.80401 10.8316L8.80401 16.9196C8.80401 16.9462 8.81455 16.9716 8.8333 16.9903C8.85206 17.0091 8.87749 17.0196 8.90401 17.0196L15.0921 17.0196C15.1186 17.0196 15.1441 17.0091 15.1628 16.9903C15.1816 16.9715 15.1921 16.9461 15.1921 16.9195L15.1867 10.8369L19.7278 10.8316C19.7682 10.8315 19.8046 10.8071 19.8201 10.7698C19.8355 10.7324 19.827 10.6894 19.7984 10.6609L12.0688 2.93124C12.0297 2.89219 11.9664 2.89219 11.9273 2.93124L4.19772 10.6609ZM8.37466 9.08455L11.998 5.46117L15.6214 9.08455L13.5451 9.08455C13.4898 9.08455 13.4451 9.12933 13.4451 9.18455L13.4451 15.2726L10.551 15.2726L10.551 9.18455C10.551 9.12933 10.5063 9.08455 10.451 9.08455L8.37466 9.08455Z"
      :fill="iconColor"
      :stroke="borderColor"
      stroke-width="0.2"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#616161"
    },

    borderColor: {
      type: String,
      default: "#616161"
    }
  }
};
</script>
